// extracted by mini-css-extract-plugin
export default {"body":"list_body__g4F83","strong":"list_strong__ZEOWA"};